import React from 'react';
import { useScopedTranslation } from '../../../../application/localization/useScopedTranslation.ts';
import { LottieContainer } from '../../../../components/animations/LottieContainer.tsx';
import animationData from '../../../../assets/animations/loader_small.json';
import { Button } from '../../../../components/uikit/buttons/Button.tsx';
import styles from '../PriceLists.module.scss';
import { downloadOrOpenBlobFile } from '../../../../helpers/download-helper.ts';
import clsx from 'clsx';
import { useAnalytics } from 'helpers/analytics.ts';
import { Tip } from '../../../../components/uikit/Tip.tsx';
import { useTranslation } from 'react-i18next';

export type DownloadButtonProps = {
  cell: any;
  processingLinks: Set<string>;
  addProcessingLink: (link: string) => void;
  removeProcessingLink: (link: string) => void;
  showTooltip: () => void;
};

const csv = 'csv';
const none = 'none';
export const PriceListCategory = 'Price-list';

export const DownloadButton = (props: DownloadButtonProps) => {
  const i18n = useScopedTranslation('Page.PriceLists');
  const i18nCommon = useTranslation();

  const { trackEvent } = useAnalytics();

  const {
    cell,
    removeProcessingLink,
    addProcessingLink,
    processingLinks,
    showTooltip,
  } = props;
  const filePath = cell.value ?? cell.data.linkPdf;
  const extension = filePath?.slice(filePath.lastIndexOf('.') + 1);

  const fileName = cell.data.name;

  const isDownload = extension === csv || !cell.value;

  const link = `${isDownload ? 'download' : 'open'}-${cell.value}`;
  const isLoading = processingLinks.has(link);

  if (cell.value === none) {
    return (
      <Tip
        tooltipText={i18nCommon.t('link_unavailable_msg')}
        textBody={
          <div className={styles.disabledButton}>
            {i18n.t(isDownload ? 'download' : 'open')}
          </div>
        }
        className={styles.tip}
        tooltipClassName={styles.margins}
      />
    );
  }

  return (
    <>
      {isLoading ? (
        <LottieContainer
          animationData={animationData}
          segments={isLoading ? [1, 180] : [180, 270]}
          loop={isLoading}
          width={28}
          height={28}
        />
      ) : (
        <div>
          <Button
            testId={isDownload ? 'download-button' : 'open-button'}
            className={clsx(styles.actionButton)}
            title={i18n.t(isDownload ? 'download' : 'open')}
            onClick={() => {
              trackEvent({
                category: PriceListCategory,
                action: isDownload ? 'Download file' : 'Open file',
                name: link,
              });
              addProcessingLink(link);
              downloadOrOpenBlobFile(filePath, fileName, !isDownload)
                .catch(showTooltip)
                .finally(() => removeProcessingLink(link));
            }}
          />
          <div className={styles.caption}>{extension}</div>
        </div>
      )}
    </>
  );
};
